import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface AuthUser {
  id: number
  gebruikersnaam: string
  volledige_naam?: string | null
  email?: string | null
  rol: string // 'superadmin' | 'admin' | 'user'
  organisation_id?: number | null
  organisation_naam?: string | null
  actief: boolean
}

interface AuthState {
  token: string | null
  user: AuthUser | null
  setSession: (token: string, user: AuthUser) => void
  logout: () => void
  isSuperadmin: () => boolean
  isAdminOrSuper: () => boolean
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      setSession: (token, user) => set({ token, user }),
      logout: () => set({ token: null, user: null }),
      isSuperadmin: () => get().user?.rol === 'superadmin',
      isAdminOrSuper: () => {
        const r = get().user?.rol
        return r === 'superadmin' || r === 'admin'
      },
    }),
    { name: 'voorraad-kh-auth' }
  )
)
